import { Page } from '@tunasong/icons'
import { useElementTypeMedia } from '@tunasong/plugin-lib'
import type { Entity } from '@tunasong/schemas'
import { useRef, type FC } from 'react'
import { getIconColorCSS } from '../color/color.js'

interface EntityIconProps {
  entity: Pick<Entity, 'type'>
  size?: 'small' | 'medium' | 'large' | 'tiny'
  /** If true, show the icon in the entity color, also when color is specified. @default true */
  active?: boolean
  DefaultIcon?: FC<{ className?: string }>
}

export const EntityIcon: FC<EntityIconProps> = props => {
  const { entity, active = true, size = 'medium', DefaultIcon = Page } = props
  const { icon: Icon, materialColor: color } = useElementTypeMedia(entity.type)
  const ref = useRef<SVGSVGElement>(null)

  const iconColor = active ? getIconColorCSS(color) : 'inherit'

  return entity ? (
    <div style={{ color: iconColor }}>
      <Icon
        ref={ref}
        size={size === 'tiny' ? 12 : size === 'small' ? 16 : size === 'medium' ? 24 : 32}
        color={iconColor}
      />
    </div>
  ) : (
    <DefaultIcon />
  )
}
